import { createElement } from 'react';
import { C as Caption$1, _ as __assign } from '../../index.esm-5f955dcb.js';
import 'react-measure';
import 'react-router-dom';
import 'react-dom';
import 'throttle-debounce';
import 'focus-trap-react';
import 'react-swipeable';
import 'react-animate-height';
import 'country-flag-emoji-polyfill';
import 'intersection-observer';
import 'html-react-parser';

var Caption = function Caption(props) {
  return /*#__PURE__*/createElement(Caption$1, __assign({}, props));
};
Caption.displayName = 'Caption';

export { Caption };
